import Geocode from 'react-geocode';

export const getGeocode = async (address: string) => {
  // set Google Maps Geocoding API for purposes of quota management. Its optional but recommended.
  process.env.REACT_APP_GOOGLE_KEY && Geocode.setApiKey(process.env.REACT_APP_GOOGLE_KEY);

  // set response language. Defaults to english.
  Geocode.setLanguage('en');
  return Geocode.fromAddress(address)
};

export const getGeoCodeFromCoordinates = async (lat: number, lng: number) => {
  process.env.REACT_APP_GOOGLE_KEY && Geocode.setApiKey(process.env.REACT_APP_GOOGLE_KEY);
  Geocode.setLanguage('en');
  return Geocode.fromLatLng(lat.toString(), lng.toString())
}
